<template>
    <main>

        <div class="row">
            <div class="col-md-6">
                <div class="titles">
                    <h2 class="uppercase"><b><i class="fa fa-cogs"></i> Cadastre as perguntas</b></h2>
                </div>
            </div>
            <div class="col-sm-6">
                <button class="btn-large-40 btn-success uppercase pull-right" @click="openCreate()">
                    Criar
                </button>
            </div>
            <div class="col-sm-12">

                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Ordem</th>
                                <th>Pergunta<i @click="executeOrderBy('Pergunta')" class="fa fa-sort"></i></th>
                                <th>Ativo<i @click="executeOrderBy('EhAtivo')" class="fa fa-sort"></i></th>
                                <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                <td>{{ item.ordem }}</td>
                                <td><div v-html="item.pergunta"></div></td>
                                <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ehAtivo, 'badge-danger': !item.ehAtivo }">{{item.ehAtivo ? 'Sim' : 'Não'}}</span></td>

                                <td class="text-center">
                                    <button type="button" class="btn btn-sm btn-green" v-b-tooltip title="Respostas" @click="openResposta(item)">
                                        <i class="fa fa-question"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar" @click="openEdit({ questaoPerguntaId: item.questaoPerguntaId })">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Excluir" @click="openRemove({ questaoPerguntaId: item.questaoPerguntaId })">
                                        <i class="fa fa-trash-o"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="card-block no-padding">
                    <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                </div>
            </div>

            <div class="col-md-12 pt-3" v-if="tipoResposta">
                <div class="alert alert-info">
                    <strong>{{tipoResposta.nome}}</strong><br /> {{tipoResposta.ajuda}}
                </div>
                <br />
            </div>

        </div>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" :questao-id="questaoId" :tipo-resposta-id="questao.tipoRespostaId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :questao-id="questaoId" :tipo-resposta-id="questao.tipoRespostaId" :id="questaoPerguntaId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogResposta" :hide-footer="true" title="Respostas">
            <questao-pergunta-resposta v-if="dialogResposta" :pode-editar="podeEditarResposta" :questao-pergunta-id="questaoPerguntaId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>
    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    import QuestaoPerguntaResposta from './questaoperguntaresposta'

    export default {
        name: 'questaopergunta',
        mixins: [base],
        components: { formCreate, formEdit, QuestaoPerguntaResposta },
        props: { questaoId: Number },
        data() {
            return {

                resources: {
                    filter: 'questaopergunta',
                    remove: 'questaopergunta'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,
                dialogResposta: false,

                model: {},
                questao: {},
                tipoResposta: {},

                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        computed: {
            podeEditarResposta: function () {
                //console.log("questao.tipoRespostaId... podeEditar",this.questao.tipoRespostaId != 2)
                return this.questao.tipoRespostaId != 2;
            }
        },
        methods: {
            openResposta: function (model) {
                this.questaoPerguntaId = model.questaoPerguntaId;
                this.dialogResposta = true;
            },
            openEdit: function (model) {
                //console.log(model.questaoPerguntaId);
                this.questaoPerguntaId = model.questaoPerguntaId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                this.filter.questaoId = this.questaoId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
            new Api('questao').get({ id: this.questaoId }).then(data => {
                this.questao = data.data;
                console.log("questão ....", this.questao);
                new Api("auxtiporesposta").get({ id: this.questao.tipoRespostaId }).then(data => {
                    this.tipoResposta = data.data;
                    console.log("questão resposta ....", this.tipoResposta);
                })
            })
        }

    };
</script>